import React from 'react';
import DynamicSiteForm from './DynamicSiteForm';

const RoomReservationForm = ({ onClose }) => (
  <DynamicSiteForm formKey="room-reservation" onClose={onClose} />
);

export default RoomReservationForm;
